module.exports = __webpack_public_path__ + "img/order.a1fd5044.jpg";